module.exports = __webpack_public_path__ + "static/media/logo.da725620.png";